
<template>
  <div class="spinner-master">
    <div id="spinner-form" class="spinner-spin">
      <div class="spinner diagonal part-1"></div>
      <div class="spinner horizontal"></div>
      <div class="spinner diagonal part-2"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopMenuResponsive'
}
</script>



// WEBPACK FOOTER //
// src/components/menus/TopMenuResponsive.vue